import { Validators } from "@angular/forms";
import { FormField } from "./form-field.model";
import { getTodayFormatted } from "../../../shared/utils";

export const CLIENT_PACKAGE_FORM: { [key: string]: FormField } = {
    clientPackageId: {
        id: 'clientPackageId',
        type: 'hidden',
        name: 'clientPackageId',
        label: 'ID',
        placeholder: "ID",
        value: 0,
        data: [],
        validators: [],
        errorMessages: {} 
    },
    resellerPackageId: {
        id: 'resellerPackageId',
        type: 'select',
        name: 'resellerPackageId',
        label: 'Corso',
        placeholder: "Seleziona Corso",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Selezionare un corso è obbligatorio."
        }
    },
    clientId: {
        id: 'clientId',
        type: 'select',
        name: 'clientId',
        label: 'Cliente',
        placeholder: "Seleziona Cliente",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Selezionare un cliente è obbligatorio."
        }
    },
    soldLicenses: {
        id: 'soldLicenses',
        type: 'number',
        name: 'soldLicenses',
        label: 'Numero licenze',
        placeholder: "Inserisci numero di licenze da assegnare al cliente",
        value: '',
        data: [],
        validators: [Validators.required, Validators.min(1)],
        errorMessages: {
            required: "Inserire il numero di licenze è obbligatorio.",
            min: "Il numero di licenze deve essere almeno 1."
        }
    },
    orderType: {
        id: 'orderType',
        type: 'text',
        name: 'orderType',
        label: 'Codice Commessa',
        placeholder: "Inserisci codice commessa",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il codice commessa è obbligatorio.",
            maxlength: "Il codice commessa puó contenere al massimo 50 caratteri."
        }
    },
    creationDate: {
        id: 'creationDate',
        type: 'text',
        name: 'creationDate',
        label: 'Data Creazione',
        placeholder: '',
        value: getTodayFormatted(),
        data: [],
        validators: [],
        errorMessages: {},
        disabled: true
    }
};
